export const FILTERS_BREAKPOINT = 'md';
export const PAGE_PARAM = 'p';
export const SEARCH_PARAM = 'q';
export const IDS_PARAM = 'id';
